<script>
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';

    const dispatch = createEventDispatcher();
    export var rdv;
    //export var db;
    //export var user;
    var heurefinale;
    onMount(async () => {
		heurefinale = rdv.jour + " - " + rdv.vheure
	});
    const decrement = firebase.firestore.FieldValue.increment(-1);



    var truc;



    var text = rdv.vheure;

    function heure(){
        text = rdv.vheure
        truc.style.color = '#fff';
    }
    function place(){
        var cmp = rdv.place<2 ? " place " : " places"
        text = rdv.place + cmp
        if (rdv.place == 8){
            truc.style.color = "#1AE05C";
        }
        else if (rdv.place == 7){
            truc.style.color = "#3BC569";
        }
        else if (rdv.place == 6){
            truc.style.color = "#5FA777";
        }
        else if (rdv.place == 5){
            truc.style.color = "#7ABD91";
        }
        else if (rdv.place == 4){
           truc.style.color = "#a6bd7a";
        }
        else if (rdv.place == 3){
            truc.style.color = "#FFB3A5";
        }
        else if (rdv.place == 2){
            truc.style.color = "#FF8989";
        }
        else if (rdv.place == 1){
            truc.style.color = "#FF6962";
        }
    }

    function choixRdv(){
        dispatch('setrdv',{heurefinale:heurefinale,id:rdv.id})
        annuler()
    }


    function confirm1(){
        document.getElementById("modal_rdv").style.display="flex"
    }
   
    function annuler(){
        document.getElementById("modal_rdv").style.display="none"
    }

</script>

{#if rdv.place<1}
<div class="cardunvalid" >
    Plus de place
    </div>
{:else}
<div class="card" bind:this={truc} on:mouseover={place} on:mouseout={heure} on:click={choixRdv}>
    {text}
    </div>
{/if}

<!--<button on:click={()=>dispatch('setrdv',{heurefinale:heurefinale})}>{rdv.vheure}</button>-->

<style>
    .card{
        cursor: pointer;
        user-select: none;
        width: 8vw;
        min-height: 5vh;
        background-color: #262626;
        box-shadow:  5px 5px 10px #151515,
         -5px -5px 10px #373737;
         display: flex;
         align-items: center;
         justify-content: center;
         font-family: 'Poppins', sans-serif;
         font-weight: 700;
         font-size: 2rem;
         margin: 15px;
         border-radius: 15px;
         padding: 10px;
    }
    .card:hover{
        transform: scale(1.025);
        font-size: 1.6rem;
    }

    .cardunvalid{
        cursor:not-allowed;
        user-select: none;
        width: 8vw;
        min-height: 5vh;
        background-color: gray;
        box-shadow:  5px 5px 10px #151515,
         -5px -5px 10px #373737;
         display: flex;
         align-items: center;
         justify-content: center;
         font-family: 'Poppins', sans-serif;
         font-weight: 400;
         font-size:1.2rem;
         margin: 15px;
         border-radius: 15px;
         padding: 10px;
    }

    
</style>